import { useAppDispatch, useAppSelector } from '@/hooks/redux';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import {   encuestaUser } from '../../store/user/userActions';
 
import { reset, resetUserCreate } from '@/store/user/userSlice';
import * as Yup from 'yup';
import TabNavigation from '../molecules/TabNavigation';
import { getEventoById } from '@/store/eventos/eventosActions';

export interface NewUserValues {
   opcion_1: string;
  mensaje: string;
    evento: string;
}

const EncuestaEventoForm = () => {
  const initialValues: NewUserValues = { 
     opcion_1:'Si',
      mensaje:'',
     evento: '',
   };
  const dispatch = useAppDispatch();
    const { eventoId } = useParams();
  const { newEncuestaError, newEncuestaLoading, newEncuestaSuccess } = useAppSelector(state => state.user);
  const [addError, setAddError] = useState(false);
  const [addSuccess, setAddSuccess] = useState(false);
  
  const dataEvento = useAppSelector((state) => state.eventos?.itemIdData);


  const validationSchema = Yup.object().shape({
    
    mensaje: Yup.string()
      .required('Este campo es obligatorio')
      .min(0, 'Este campo es obligatorio')
      .matches(/^\s*\S[^]*$/, 'Este campo es obligatorio'),
  });

  useEffect(() => {
  if (eventoId) {
    formik.setFieldValue('evento', dataEvento?.Titulo);
  }
}, [dataEvento]);


  useEffect(() => {
    if (eventoId) {
      dispatch(getEventoById({ id: parseInt(eventoId.split("-")[0]) }));
    }
  }, [dispatch]);

  useEffect(() => {
    if (newEncuestaError) {
      setAddError(true);
    }
    if (newEncuestaSuccess) {
      //formik.resetForm();
     // formik.setValues(initialValues);
      setAddSuccess(true);
    
     }
  }, [newEncuestaError, newEncuestaSuccess]);

  const formik = useFormik({
    initialValues,
    onSubmit: async values => {
      setAddError(false);
      setAddSuccess(false);
      await dispatch(encuestaUser(values));
    },
    validationSchema: validationSchema,
    validateOnMount: false,
    validateOnChange: false,
    validateOnBlur: false,
  });
 

  return (
    <>
      <Container>
        
     
          <div className="row g-4">
            
                   <Form.Group className="col-md-12">
                        <p>
                       ¿Sentís que lo aprendido te ayudará en tus consultas para acompañar a tus consultantes a descubrirse como creadores?
                        </p>
                      <Form.Check
                       disabled={addSuccess}
                          type="radio"
                          id="opcion_1_1"
                          label="Si"
                          name="opcion_1"
                          value="Si"
                          checked={formik.values.opcion_1 == "Si"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={formik.errors.opcion_1 ? true : false}
                          feedback={formik.errors.opcion_1}
                          required
                      />
                      <Form.Check
                       disabled={addSuccess}
                          type="radio"
                          id="opcion_1_2"
                          label="No"
                          name="opcion_1"
                          value="No"
                          checked={formik.values.opcion_1 == "No"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={formik.errors.opcion_1 ? true : false}
                          feedback={formik.errors.opcion_1}
                          required
                      />
                      <Form.Check
                       disabled={addSuccess}
                          type="radio"
                          id="opcion_1_3"
                          label="Aún no soy consultor"
                          name="opcion_1"
                          value="Aún no soy consultor"
                          checked={formik.values.opcion_1 == "Aún no soy consultor"}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          isInvalid={formik.errors.opcion_1 ? true : false}
                          feedback={formik.errors.opcion_1}
                          required
                      />
                      <br/>
                      </Form.Group>

                  

                      
                       <Form.Group className="col-md-12">
                            
                              <p>
                        ¡Esta es una gran oportunidad para seguir creciendo y mejorando juntos! Tus comentarios son muy valiosos y nos ayudan a seguir aprendiendo.
                        </p>
                                <Form.Control
                                  onBlur={formik.handleBlur}
                                  isInvalid={formik.errors.mensaje ? true : false}
                                  required
                                  as="textarea"
                                   readOnly={addSuccess}
                                  rows={6}
                                  maxLength={2000}
                                  value={formik.values.mensaje}
                                  placeholder="Mensaje"
                                  onChange={formik.handleChange}
                                  name="mensaje"
                                />
                                <Form.Control.Feedback type="invalid">{formik.errors.mensaje}</Form.Control.Feedback>
                          </Form.Group>
                 
               
                {!addSuccess && (
  <div className="col d-grid mb-5">
    <Button className="btn btn-primary" onClick={() => formik.handleSubmit()}>
      Enviar
    </Button>
  </div>
)}
        
        </div>
        {addSuccess && (
          <>
           <p></p>  
            <Alert variant="success" dismissible onClose={() => setAddSuccess(false)}>
              <Alert.Heading>¡Muchas Gracias!</Alert.Heading>
              <p>Se envio su encuesta correctamente</p>
            </Alert>
          </>
        )}
        {addError && (
          <Alert variant="danger" dismissible onClose={() => setAddError(false)}>
            <Alert.Heading>¡Ups, algo salió mal!</Alert.Heading>
            <p>Intenta nuevamente</p>
          </Alert>
        )}

      </Container>
      {newEncuestaLoading && (
        <div>Aguarde un instante...</div>
      )}
    </>
  );
};

export default EncuestaEventoForm;
